// @ts-nocheck
// TODO: tighten types after migration
import { useEffect } from "react";
import { API_ENDPOINTS } from "../config/api";

const HEARTBEAT_INTERVAL = 2 * 60 * 1000; // 2 minutes

export default function UserHeartbeat() {
    useEffect(() => {
        const sendHeartbeat = () => {
            const token = sessionStorage.getItem("token");
            if (!token) return;
            fetch(API_ENDPOINTS.USER.HEARTBEAT, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                credentials: "include",
            }).catch(() => { /* best-effort, ignore errors */ });
        };

        sendHeartbeat();
        const interval = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
        return () => clearInterval(interval);
    }, []);

    return null;
}
